module.exports = __webpack_public_path__ + "static/img/bg.563344e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ad-banner/doublelift-course/bg.png
// module id = sA4k
// module chunks = 35